import { render, staticRenderFns } from "./StepGroup.vue?vue&type=template&id=2f543237&scoped=true&"
import script from "./StepGroup.vue?vue&type=script&lang=js&"
export * from "./StepGroup.vue?vue&type=script&lang=js&"
import style0 from "./StepGroup.vue?vue&type=style&index=0&id=2f543237&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f543237",
  null
  
)

export default component.exports